
import MenuItemsList from 'Core/containers/Sidebar/.components/MenuItemsList';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import cx from "classnames";
import packageJson from '../../../../package.json'

import Drawer from '@mui/material/Drawer';

//Styles
import "./sidebar.scss";

const Sidebar = (props) => {
  const { changePreferences } = props

  const theme = useTheme();

  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const open = useSelector(state => state.commonRedux.sidebarShow);

  return (
    <Drawer
      variant={isLargeScreen ? "permanent" : "temporary"}
      open={open}
      classes={{
        paper: cx("drawer-container", !open ? "drawer-container-close" : "drawer-container-open"),
      }}
    >
      <MenuItemsList changePreferences={ changePreferences} />
      {open &&
        <div className="drawer-container-version">
          {`v ${packageJson.version}`}
        </div>
      }
    </Drawer>
  )
}

export default Sidebar;
